module.exports = __webpack_public_path__ + "static/img/about_bg_06_zh.07ded72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_bg_06_zh.png
// module id = Y4SC
// module chunks = 34